import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import useWindowSize from '@repo/ui/src/hooks/useWindowSize';
import BackgroundVideo from '@repo/ui/src/components/BackgroundVideo';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';

interface ScrollProps {
  headingLight?: string;
  heading?: string;
  align?: any;
  description?: string;
  video: MediaType;
}

const AccessoryScroll = ({ headingLight, heading, align, description, video }: ScrollProps) => {
  const { width = 0 } = useWindowSize();
  const vidWidth = width > 1920 ? 1920 : width;

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.start-trig',
        pin: '.accessory-video',
        pinSpacing: false,
        start: 'top top',
        // markers: true,
        end: '+=50%',
        toggleActions: 'play complete pause reverse',
      },
    });

    //.3 opacity for text scroll in
    tl.fromTo('.accessory-video', { opacity: 1 }, { opacity: 0.3, duration: 0.5 });
    const secondTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.sec-trig',
        start: 'center top',
        toggleActions: 'play complete pause reverse',
        // markers: true,
      },
    });
    // fade all the way to black when text halfway
    secondTl.to('.accessory-video', { opacity: 0, duration: 0.5 });
    secondTl.fromTo('.accCard', { opacity: 0 }, { opacity: 1, duration: 0.5 });
  }, []);
  return (
    <div className="scroll-wrapper bg-neutral-800">
      <div className="start-trig [&_div]:absolute [&_div]:top-0 [&_div]:bottom-0 [&_div]:h-screen [&_div_video]:!w-full">
        <BackgroundVideo
          video={video}
          width={vidWidth}
          fillContainer
          className={`accessory-video`}
          playButton
        />
      </div>
      <div className="max-w-[1680px] mx-auto">
        <div className="relative h-[120vh] flex items-end pt-[4.5rem] px-6 md:pt-[9.25rem] md:px-12">
          <ToutContent
            headingLight={headingLight}
            heading={heading}
            align={align}
            headingStyleVariant="h1"
            divider
            dark
            description={description}
            className="sec-trig"
          />
        </div>
      </div>
    </div>
  );
};

export default AccessoryScroll;
